import { Controller } from "@hotwired/stimulus"
import Tobii from '@midzer/tobii'

export default class extends Controller {
  connect() {
    new Tobii({ zoom: false });
  }
}
